module.exports = __webpack_public_path__ + "img/icon_jianrong@2x.56e69411.png";